import { withStyles } from '@material-ui/styles';
import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import * as v from '../../../helpers/validation';
import { DynamicForm } from '../../DynamicForm';
// SERVICES
import { createUserRestrictions, getAgents, getClientList, getFormHeaders, getUsers } from '../../../services';

const styles = theme => ({
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  existingLogo: {
    height: '100%',
    maxHeight: 150,
  },
});

export const RestrictionsCreate = withStyles(styles)(props => {
  const { match } = props;
  const [clientList, setClientList] = useState([]);
  const [formHeaderList, setFormHeaderList] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [userList, setUserList] = useState([]);

  useEffect(() => {
    getUserListAsync();
    getClientListAsync();
    getFormHeaderListAsync();
    getAgentListAsync();
  }, []);

  const getUserListAsync = async () => {
    let users = await getUsers();
    users = users.map(u => {
      return {
        value: u.id,
        label: u.name,
      };
    });
    setUserList(users);
  };

  const getClientListAsync = async () => {
    let clients = await getClientList();
    clients = clients.map(c => {
      return {
        value: c.id,
        label: `${c.name} ${c.code && `(${c.code})`}`,
      };
    });
    setClientList(clients);
  };

  const getFormHeaderListAsync = async () => {
    let formHeaders = await getFormHeaders();
    formHeaders = formHeaders.map(fh => {
      return {
        value: fh.formHeaderId,
        label: `${fh.name}`,
      };
    });
    setFormHeaderList(formHeaders);
  };

  const getAgentListAsync = async () => {
    let agents = await getAgents();
    agents = agents.map(a => {
      return {
        value: a.id,
        label: `${a.agentName}`,
      };
    });
    setAgentList(agents);
  };

  const restrictionInputs = [
    {
      inputType: 'gridcontainer',
      children: [
        {
          inputType: 'griditem',
          children: [
            {
              inputType: 'select',
              field: 'userIds',
              label: 'Users',
              validate: [],
              options: userList,
              isMulti: true,
            },
            {
              inputType: 'select',
              field: 'clientIds',
              label: 'Clients',
              validate: [],
              options: clientList,
              isMulti: true,
            },
            {
              inputType: 'select',
              field: 'formHeaderIds',
              label: 'Form Headers',
              validate: [],
              options: formHeaderList,
              isMulti: true,
            },
            {
              inputType: 'select',
              field: 'agentMasterIds',
              label: 'Agents',
              validate: [],
              options: agentList,
              isMulti: true,
            },
          ],
        },
      ],
    },
  ];

  return (
    <div className={classnames('grid-container')}>
      <div>
        *User Restrictions are managed by exception. Users will only be restricted from assignment to Clients, Form
        Headers, and Agents that are specified below.
      </div>
      <DynamicForm
        inputs={restrictionInputs}
        mode={'CREATE'}
        onSave={createUserRestrictions}
        redirectOnSuccess={'/users/restrictions'}
      />
    </div>
  );
});
